import {
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
  createReactRouterV6Options,
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

const PII_KEYS = ['cpf', 'nome', 'email', 'telefone'];

function redactPII(item) {
  if (item?.payload?.attributes) {
    PII_KEYS.forEach((k) => delete item.payload.attributes[k]);
  }
  return item;
}

async function hashValue(value) {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, 16);
}

export async function setFaroCedenteUser(cpf) {
  try {
    const { faro } = await import('@grafana/faro-react');
    faro.api.setUser({ id: await hashValue(cpf) });
  } catch (_) {}
}

export async function setFaroAdminUser(roleName, email = null) {
  try {
    const { faro } = await import('@grafana/faro-react');
    const id = email ? await hashValue(email) : roleName;
    faro.api.setUser({ id, username: roleName });
  } catch (_) {}
}

export async function clearFaroUser() {
  try {
    const { faro } = await import('@grafana/faro-react');
    faro.api.resetUser();
  } catch (_) {}
}

export function setupTelemetry() {
  if (process.env.REACT_APP_ENV === 'development') return;

  initializeFaro({
    url: 'https://faro-collector-prod-sa-east-1.grafana.net/collect/a57f602b455d3b0de96cff18b2757959',
    app: {
      name: 'Assinaturas',
      version: process.env.REACT_APP_VERSION || '1.0.0',
      environment: process.env.REACT_APP_ENV || 'production',
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation(),
      new ReactIntegration({
        router: createReactRouterV6Options({
          createRoutesFromChildren,
          matchRoutes,
          Routes,
          useLocation,
          useNavigationType,
        }),
      }),
    ],
    beforeSend: redactPII,
    ignoreErrors: [
      /^ResizeObserver loop limit exceeded$/,
      /^ResizeObserver loop completed with undelivered notifications$/,
      /^Script error\.$/,
      /chrome-extension:\/\//,
      /moz-extension:\/\//,
    ],
  });
}
